import { OnInit, OnChanges } from '@angular/core';
import { Menu } from '../../shared/menu/menu.model';
import { Subscription } from 'rxjs';
import { FullMenuService } from '../full-menu.service';
var FullMenuCategoryContainerComponent = /** @class */ (function () {
    function FullMenuCategoryContainerComponent(fullMenuService) {
        this.fullMenuService = fullMenuService;
    }
    FullMenuCategoryContainerComponent.prototype.ngOnInit = function () {
        this.fetchSelectedMenuOptions();
    };
    FullMenuCategoryContainerComponent.prototype.ngOnChanges = function () {
        this.fetchSelectedMenuOptions();
    };
    FullMenuCategoryContainerComponent.prototype.fetchSelectedMenuOptions = function () {
        var _this = this;
        this.selectedMenuOptionsSubscription = this.fullMenuService.getCurrentMenuOptions().subscribe(function (options) {
            _this.selectedMenuOptions = options;
        });
        this.fullMenuService.getMenuTabindex().subscribe(function (menuTabIndex) {
            _this.menuTabIndex = menuTabIndex;
        });
    };
    FullMenuCategoryContainerComponent.prototype.ngOnDestroy = function () {
        this.selectedMenuOptionsSubscription.unsubscribe();
    };
    return FullMenuCategoryContainerComponent;
}());
export { FullMenuCategoryContainerComponent };
